import { SET_CUSTOMER_CERTIFICATE } from "../actions/actions.types";

const INITIAL_STATE: any = {
  customerCertificate: [],
};

const customerCertificateReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_CUSTOMER_CERTIFICATE:
      return { ...state, customerCertificate: action.customerCertificate };
    default:
      return state;
  }
};

export default customerCertificateReducer;
